module.exports = __webpack_public_path__ + "img/fireworks-2023.e01cf52f.png";